const moment = require('moment');
const { dateFormat } = require("../../constants/Formatos");

const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];
/**
 * Devuelve la diferencia de días entre dos fechas
 * @param {*} initDate
 * @param {*} endDate
 * @returns
 */
const daysBetweenDates = (initDate, endDate) => {
    let days = NaN;

    try {
        const init = moment(initDate);
        const end = moment(endDate);
        days = end.diff(init, "days");
    } catch (error) {
        console.debug(
            "Error en rango de fechas proporcionado",
            initDate,
            endDate,
            error
        );
    }
    return days;
};

/**
 * Valida que el valor de fecha proporcionado corresponda con el formato de fecha especificado
 * @param {*} fecha 
 * @param {*} formato 
 * @returns 
 */
const isValidDate = (fecha, formato) => {
    var m = moment(fecha, formato || dateFormat, true);
    return m.isValid();
};

/**
 * Obtiene un objeto con el inicio y fin de la semana actual
 * @returns 
 */
const getSemanaActual = () => {
    const inicial = moment().startOf("isoWeek").format(dateFormat);
    const final = moment(inicial).add(6, "days").format(dateFormat);
    return { inicial, final };
};

/**
 * Obtiene la fecha despues de agregar N cantidad de días
 * @param {string} fecha formateada en string
 * @param {number} dias 
 * @returns 
 */
const addDays = (fecha, dias) => {
    return moment(fecha, dateFormat).add(dias, "days").format(dateFormat);
};

/**
 * Obtiene la fecha despues de agregar N cantidad de días
 * @param {string} fecha formateada en string
 * @param {number} años 
 * @returns 
 */
const addYears = (fecha, años) => {
    return moment(fecha, dateFormat).add(años, "years").format(dateFormat);
};

/**
 * Obtiene la fecha despues de agregar N cantidad de días
 * @param {string} fecha formateada en string
 * @param {number} años 
 * @param {string} formato
 * @returns 
 */
const addYearsFormat = (fecha, años, formato = formatDate) => {
    return moment(fecha, formato).add(años, "years").format(formato);
};

/**
 * Obtiene la fecha actual en el formato especificado
 * @param {string} formato 
 * @returns 
 */
const getCurrentDate = (formato = dateFormat) => {
    return moment(new Date()).format(formato);
};

/**
 * Formatea una fecha con el formato especificado
 * @param {string} formato 
 * @returns 
 */
const formatDate = (fecha, formato = dateFormat) => {
    return moment(fecha).format(formato);
};

/**
 * Convierte una fecha con formato DD/MMM/YYYY a español
 * @param {string} formato 
 * @returns 
 */
const convertDateToSpanish = (fecha) => {
    const fechaMoment = moment(fecha, "DD/MMM/YYYY");

    if (fechaMoment.isValid) {
        fecha = fecha.split("/");
        const mes = meses[fechaMoment.month()].toLowerCase().substring(0, 3);

        return `${fecha[0]}/${mes}/${fecha[2]}`;
    }

    return fecha;
};

const convertMonthToSpanish = (fecha) => {
    const fechaMoment = moment(fecha, "DD/MMM/YYYY");

    if (fechaMoment.isValid) {
        return meses[fechaMoment.month()];
    }

    return fecha;
};

const getCurrentDay = (yesterday = false, lastYear = false, isoFormat = false, startYear = false) => {
    const now = new Date();

    // Si se requiere la fecha de ayer, restamos un día.
    if (yesterday) {
        now.setDate(now.getDate() - 1);
    }

    if (lastYear) {
        now.setFullYear(now.getFullYear() - 1);
    }

    if (isoFormat) {
        return now.toISOString().split('T')[0]; // Devuelve solo la fecha en formato YYYY-MM-DD
    }

    if (startYear) {
        now.setMonth(0);
        now.setDate(1);
    }

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const formatDateIsoDate = (isoDate, time = false) => {
    const months = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const date = new Date(isoDate);

    const day = date.getDate(); // Get the day (1-31)
    const month = months[date.getMonth()]; // Get the month's name
    const year = date.getFullYear(); // Get the year

    let dateAns = `${day} ${month} ${year}`;
    if (time) {
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");

        // Convert to 12-hour format and determine AM/PM
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // Convert 0 (midnight) to 12

        dateAns += `, ${hours}:${minutes} ${ampm}`;
    }

    return dateAns;
};

const formatDateGrid = (isoDate) => {
    const months = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const date = new Date(isoDate.value);

    const day = date.getDate(); // Get the day (1-31)
    const month = months[date.getMonth()]; // Get the month's name
    const year = date.getFullYear(); // Get the year

    let dateAns = `${day} ${month} ${year}`;

    return dateAns;
};

module.exports = {
    daysBetweenDates,
    isValidDate,
    getSemanaActual,
    addDays,
    addYears,
    addYearsFormat,
    getCurrentDate,
    formatDate,
    convertDateToSpanish,
    convertMonthToSpanish,
    getCurrentDay,
    formatDateIsoDate,
    formatDateGrid,
    meses
};